import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Column, Columns } from '../../../base/grid';
import { P } from '../../../base/typography';
import * as StyledServiceLevelCards from './serviceLevelCards.styles';

interface Props {
	data: any;
	cardsToShow: number;
}

const ServiceLevelCards: FC<Props> = ({ data, cardsToShow }) => {
	const { t } = useTranslation('generalPostInfo');
	if (!data) return null;
	return (
		<StyledServiceLevelCards.Wrapper>
			<Columns>
				{data.slice(0, cardsToShow).map(postcode => (
					<Column desktopSmall={1 / 3} key={postcode.postcode}>
						<StyledServiceLevelCards.CardWrapper>
							<StyledServiceLevelCards.Heading>{postcode.postcode}</StyledServiceLevelCards.Heading>
							<StyledServiceLevelCards.Content>
								<P>
									<strong>{`${t('service-level.place')}: `}</strong>
									{postcode.city}
								</P>
								{postcode.postoffice !== '' && (
									<P>
										<strong>
											{postcode.postoffice.toLowerCase() === 'landpóstur' ||
											postcode.postoffice.toLowerCase() === 'póstbíll' ||
											postcode.postoffice.toLowerCase().indexOf('pósthólf') !== -1
												? `${t('service-level.service')}: `
												: `${t('service-level.postoffice')}: `}
										</strong>
										{postcode.postoffice}
									</P>
								)}
								{postcode.partner !== '' && (
									<P>
										<strong>{`${t('service-level.partner')}: `}</strong>
										{postcode.partner}
									</P>
								)}
								{postcode.openingHours !== '' && (
									<P>
										<strong>{`${t('service-level.opening-hours')}: `}</strong>
										{postcode.openingHours}
									</P>
								)}
								{postcode.homeDeliveryIndividuals !== '' && (
									<P>
										<strong>{`${t('service-level.home-delivery-individual')}: `}</strong>
										{postcode.homeDeliveryIndividuals}
									</P>
								)}
								{postcode.homeDeliveryCompanies !== '' && (
									<P>
										<strong>{`${t('service-level.home-delivery-companies')}: `}</strong>
										{postcode.homeDeliveryCompanies}
									</P>
								)}
								{postcode.servicePostoffice !== '' && (
									<P>
										<strong>{`${t('service-level.service-postoffice')}: `}</strong>
										{postcode.servicePostoffice}
									</P>
								)}
								{postcode.lastReturnTime !== '' && (
									<P>
										<strong>{`${t('service-level.last-safe-dropoff-time')}: `}</strong>
										{postcode.lastReturnTime}
									</P>
								)}
								{postcode.companySupport !== '' && (
									<P>
										<strong>{`${t('service-level.company-service')}: `}</strong>
										{postcode.companySupport}
									</P>
								)}
							</StyledServiceLevelCards.Content>
						</StyledServiceLevelCards.CardWrapper>
					</Column>
				))}
			</Columns>
		</StyledServiceLevelCards.Wrapper>
	);
};

export default ServiceLevelCards;
